var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tooltip-wrapper"},[_vm._t("default"),(_vm.text)?_c('aside',{class:`tooltip tooltip--${_vm.position}${_vm.withArrow ? ` tooltip--${_vm.position}--with-arrow`: ''}`,style:(_vm.dynamicStyles)},[_c('hh-msg-display',{staticClass:"tooltip__message",attrs:{"message":_vm.text,"type":_vm.type}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }